import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { useFieldArray, useForm } from 'react-hook-form'
import {
  type MatchCoursesFormType,
  matchCourseSchema
} from '@/schemas/education/match-courses-schema'
import type {
  StudentAutomaticCoursesFormMethods,
  StudentRequestedCoursesFormMethods
} from '@/types/forms/student-requested-courses-form-methods'

export const useStudentCreditTransferForms = () => {
  const defaultPreviousEducation = {
    previousCourseName: '',
    modality: '',
    educationLevel: '',
    previousInstituitionName: '',
    file: undefined
  }

  const {
    control,
    getValues,
    reset,
    watch,
    handleSubmit,
    trigger,
    setValue,
    setError,
    formState: { errors }
  } = useForm<MatchCoursesFormType>({
    defaultValues: {
      automaticCourseEquivalences: [],
      courseEquivalences: [],
      previousEducation: defaultPreviousEducation
    },
    resolver: zodResolver(matchCourseSchema),
    mode: 'onChange'
  })

  const { fields, append, remove, update } = useFieldArray({
    control,
    name: 'courseEquivalences'
  })

  const {
    fields: automaticFields,
    append: automaticAppend,
    remove: automaticRemove
  } = useFieldArray({
    control,
    name: 'automaticCourseEquivalences'
  })

  function clearDesiredCourses() {
    const currentValues = getValues('courseEquivalences')
    currentValues.forEach((item, index) => {
      update(index, {
        desiredCourse: {
          name: '',
          workload: 0,
          id: '',
          courseId: ''
        },
        previousCourse: item.previousCourse,
        equivalenceStatus: { id: '' },
        selectedByAI: false
      })
    })
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    reset({
      // automaticCourseEquivalences: mockedStudentSelected,
      // courseEquivalences: mockedIAReturn,
      previousEducation: defaultPreviousEducation
    })
  }, [reset])

  const formMethods: StudentRequestedCoursesFormMethods = {
    append,
    remove,
    control,
    getValues,
    reset,
    fields,
    watch,
    handleSubmit,
    setError,
    trigger,
    setValue,
    errors
  }

  const formMethodsIA: StudentAutomaticCoursesFormMethods = {
    fields: automaticFields,
    control,
    getValues,
    reset,
    watch,
    handleSubmit,
    trigger,
    setValue,
    append: automaticAppend,
    remove: automaticRemove
  }

  return {
    states: {
      formMethods,
      formMethodsIA
    },
    actions: {
      clearDesiredCourses
    }
  }
}
